<template>
  <div v-if="images.length !== 0">
    <div class="img-row d-flex justify-center">
      <div class="img-row-block" v-for="(image, index) in orderImage" :key="index">
        <ShootingGalleryItem :image="image" :url="image.url" :index="index" @toggle-fullscreen="toggleFullscreen" />
        <div v-if="show === index">
          <ShootingGalleryItemFullscreen
            :url="image.url"
            :index="index"
            @toggle-fullscreen="toggleFullscreen"
            v-on:change-image="changeImage"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ShootingGalleryItem from '@/components/shooting/ShootingGalleryItem.vue'
import ShootingGalleryItemFullscreen from '@/components/shooting/ShootingGalleryItemFullscreen.vue'

export default {
  name: 'ShootingGalleryByOrder',
  components: {
    ShootingGalleryItem,
    ShootingGalleryItemFullscreen
  },
  props: {
    images: {
      type: Array,
      default: () => []
    },
    types: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      show: null
    }
  },
  computed: {
    orderImage() {
      const shooting = [...this.images]
      let storeShootingByOrder = []
      let orderedShooting = []
      let maxOrder = Math.max.apply(
        Math,
        shooting.map(function(o) {
          return o.order
        })
      )

      // Store shooting in order
      for (let i = 0; i <= maxOrder; i++) {
        storeShootingByOrder = [...storeShootingByOrder, shooting.filter(el => el.order === i)]
      }

      // recupère chaque image ayant le process le plus eloigné dans la chaine
      for (let y = 0; y < storeShootingByOrder.length; y++) {
        const shooting = storeShootingByOrder[y]
        shoot: for (let i = this.types.length - 1; i >= 0; i--) {
          for (let x = 0; x < shooting.length; x++) {
            if (shooting[x].imageType === this.types[i]) {
              orderedShooting.push(shooting[x])
              break shoot
            }
          }
        }
      }

      return orderedShooting
    }
  },
  created() {
    this.eventKey = this.eventKeyCode.bind(this)
  },
  methods: {
    changeImage(value) {
      if (value === 'PREVIOUS' && this.show > 0) this.show = this.show - 1
      if (value === 'NEXT' && this.show < this.orderImage.length - 1) this.show = this.show + 1
    },
    toggleFullscreen(e, index) {
      if (e) {
        this.show = index
        window.addEventListener('keydown', this.eventKey)
      } else {
        window.removeEventListener('keydown', this.eventKey)
        this.show = null
      }
    },
    eventKeyCode(ev) {
      if (ev.keyCode === 27) this.show = null
      if (ev.keyCode === 37 && this.show > 0) this.show = this.show - 1
      if (ev.keyCode === 39 && this.show < this.orderImage.length - 1) this.show = this.show + 1
      if (this.show === null) window.removeEventListener('keydown', this.eventKey)
    }
  }
}
</script>

<style lang="sass" scoped>
.img-row
  display: flex
  flex-wrap: wrap
  margin-bottom: 20px
</style>
